export default {
  home: 'Hello',
  switchLang: '日本語',
};



// WEBPACK FOOTER //
// ./src/config/locales/en.js